<template>
  <div class="km__modules__pattern--maincategories">
    <ul class="km__list--modules" v-if="patternMainCat !== null && patternMainCat.length > 0">
      <li class="km__list__element--modules main-pattern"
          :class="{active:Object.keys(currentPatternCategory).length === 0}">
        <div class="km__button--pattern ohne" @click="deletePatternForColorCode">
        </div>
        <span class="km__label--text">{{ $t("km_withoutpattern_ButtonDescription") }}</span>
      </li>
      <li class="km__list__element--modules main-pattern"

          v-for="(cat, index) in patternMainCat"
          :class="{active:cat.name === currentPatternCategory?.name}"
          :key="index"
      >
        <div class="km__button--pattern"
             :style="{ backgroundImage: 'url(' + '/logodatenbank/' + previewPath(cat.previewStockLogoID) + '/' + cat.previewStockLogoID + '-CategoryPreview.svg' + ')' }"
             @click="$emit('setCurrentPatternCategory', cat)"
        >
        </div>
        <span class="km__label--text">{{ cat.nameLocalized }}</span>
      </li>
    </ul>
  </div>
</template>

<script lang="ts" setup>
import {useStore} from 'vuex';
import {computed, PropType, watch} from "vue";
import {
  AnimationWaitingForTargetFactory,
  KEYFRAMETARGETS,
  KeyFrameTargetValues,
  OPEN
} from "@km/animations/animationFactory";
import {EventVerteiler} from "@k/global/eventVerteiler"
import {PATTERN_EVENTNAMES} from "@k/js/pattern/patternFactory"
import {StockLogoCategory} from "@k/js/stocklogos/stocklogoController";
import {
  scrollToActivePatternOrCategoryAfterRepaint
} from "@km/components/patternselection/scrollToActivePatternOrCategoryAfterRepaint";
import {useModuleColorOpenStateStore} from "@km/store/frontendstate/useModuleColorOpenState";

const props = defineProps({
  currentPatternCategory: Object as PropType<StockLogoCategory | null>,
  currentColorCode: String,
})
const emit = defineEmits(["setCurrentPatternCategory"]);


const store = useStore()
const openStatusStore = useModuleColorOpenStateStore();
const patternMainCat = computed(() => store.getters["StockLogoStore/getPatternCategories"]);
const animation = AnimationWaitingForTargetFactory.getLeftRightAnimationpercentWithOpacityAnimation(".km__modules__pattern--maincategories");
const keyframes = new KeyFrameTargetValues({targetValue: -100, opacity: 1}, {
  targetValue: 0,
  opacity: 0
}, {targetValue: 125, opacity: 1});
watch(() => openStatusStore.getPatternCategoriesState, (newValue: KEYFRAMETARGETS) => {
  animation(keyframes.getTarget(newValue))
  if (newValue === OPEN) {
    scrollToActivePatternOrCategoryAfterRepaint("km__modules__pattern--maincategories");
  }
});

watch(() => props.currentPatternCategory, () => {
  scrollToActivePatternOrCategoryAfterRepaint("km__modules__pattern--maincategories")
});


const previewPath = id => id.toString().slice(-2);
const deletePatternForColorCode = function (): void {
  emit("setCurrentPatternCategory", null)
  EventVerteiler.broadcast(PATTERN_EVENTNAMES.DELETED, {colorCodeNr: store.getters.getColorCodeNr(props.currentColorCode)})
};


</script>

<style lang="scss" scoped>
/* ***********************************
*	MODULE PATTERN
* -
* ********************************** */
.km__modules__pattern--maincategories {
  position: fixed;
  height: 55px;
  width: 100%;
  right: -100%;
  bottom: calc(55px + #{$cta-height});
  z-index: 999;
  overflow-y: hidden;
  opacity: 0;

  .km__list--modules {
    position: relative;
    overflow-x: scroll;
    width: 100%;
    -webkit-overflow-scrolling: touch;
    display: flex;
    flex-direction: row;
    padding-bottom: 115px;

    .km__list__element--modules {
      padding: 6px 7px;

      &.main-pattern {
        /*padding-top: 43px;*/

        &.active {

          .km__button--pattern {
            &:after {
              content: '';
              position: absolute;
              top: -5px;
              left: -5px;
              width: calc(100% + 10px);
              height: calc(100% + 10px);
              border: 2px solid $color-blue;
            }
          }
        }
      }
    }

    .km__button--pattern {
      background-size: auto 50px;

      &.ohne {
        background-image: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAyMy4wLjQsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iRWJlbmVfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHZpZXdCb3g9IjAgMCA0MCA0MCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNDAgNDA7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4NCjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+DQoJLnN0MHtmaWxsOiNBN0E4QUE7fQ0KPC9zdHlsZT4NCjxwYXRoIGNsYXNzPSJzdDAiIGQ9Ik0wLDB2NDBoNDBWMEgweiBNMTkuMywyMEwxLDM4LjJWMS43TDE5LjMsMjB6IE0xLjcsMWgzNi41TDIwLDE5LjNMMS43LDF6IE0yMCwyMC43TDM4LjMsMzlIMS43TDIwLDIwLjd6DQoJIE0yMC43LDIwTDM5LDEuN3YzNi42TDIwLjcsMjB6Ii8+DQo8L3N2Zz4NCg==');
        background-position: center;
        background-repeat: no-repeat;
        background-size: 58px;
      }
    }

    .km__label--text {
      width: 60px;
      text-overflow: clip;
      overflow: hidden;
      white-space: nowrap;
      word-break: unset;
    }
  }
}
</style>
